import { c as _c } from "react/compiler-runtime";
import { FormInput } from '@systemeio/ui';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionWebhookEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionWebhookItemProps extends EditActionItemInterface<ActionWebhookEditInterface> {}
const ActionWebhookItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    action,
    errors,
    setRules,
    onDelete,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.webhookUrl || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        renderActionLabel
      } = t3;
      return <FormInput nativeLabelProps={{
        htmlFor: "none"
      }} labelClassName="w-full" label={renderActionLabel({
        label: t("dashboard.automation_rule.webhook_url")
      })} placeholder={t("dashboard.automation_rule.type_webhook")} value={action.webhookUrl} onChange={e => setRules(prev => ({
        ...prev,
        actions: actions.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              webhookUrl: e.target.value
            };
          } else {
            return el;
          }
        })
      }))} error={errors.automationActions[action.id]?.webhookUrl?.join("")} />;
    };
    $[3] = action.id;
    $[4] = action.webhookUrl;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionWebhookItem;